var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShoothillFooterLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 219.998,
    height: 47.239,
    viewBox: "0 0 219.998 47.239",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:#009fe3;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-544 -568)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(544 568)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M106.846,29.947H98.973a3.776,3.776,0,0,1-2.756-1.181,3.649,3.649,0,0,1-1.125-2.812,4.05,4.05,0,0,1,1.125-2.812,3.928,3.928,0,0,1,2.756-1.237h13.5V18.7H99.03a6.481,6.481,0,0,0-4.949,2.137A6.913,6.913,0,0,0,92,25.955a6.752,6.752,0,0,0,2.081,5.005A6.51,6.51,0,0,0,99.03,33.04H106.9a3.777,3.777,0,0,1,2.756,1.181,3.731,3.731,0,0,1,1.125,2.812,3.67,3.67,0,0,1-3.88,3.88H92.787v3.149H106.9a7.1,7.1,0,0,0,7.086-7.086,6.876,6.876,0,0,0-2.081-5.061A7.09,7.09,0,0,0,106.846,29.947Z",
    transform: "translate(-40.262 -8.184)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M143.936,10.729h-5.342V.1H135.5V35.979h3.093v-22.1h5.455a9.409,9.409,0,0,1,9.448,9.5v12.6h3.149v-12.6a11.889,11.889,0,0,0-3.712-8.942A12.011,12.011,0,0,0,143.936,10.729Z",
    transform: "translate(-59.299 -0.044)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M319.935,10.729h-5.342V.1H311.5V35.979h3.093v-22.1h5.455a9.409,9.409,0,0,1,9.448,9.5v12.6h3.149v-12.6a11.889,11.889,0,0,0-3.712-8.942A12.012,12.012,0,0,0,319.935,10.729Z",
    transform: "translate(-136.322 -0.044)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M190.153,20a11.738,11.738,0,0,0-8.942,3.768,12.1,12.1,0,0,0-3.712,9,11.889,11.889,0,0,0,3.712,8.942,12.188,12.188,0,0,0,8.942,3.712,11.853,11.853,0,0,0,8.885-3.712,12.188,12.188,0,0,0,3.712-8.942,12.186,12.186,0,0,0-3.712-9A11.7,11.7,0,0,0,190.153,20Zm6.692,19.4a9.183,9.183,0,0,1-6.636,2.812H190.1a9.5,9.5,0,0,1-6.692-16.2,9.311,9.311,0,0,1,6.692-2.812h.112a9.183,9.183,0,0,1,6.636,2.812,9.5,9.5,0,0,1,0,13.384Z",
    transform: "translate(-77.68 -8.753)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M238.253,20a11.738,11.738,0,0,0-8.942,3.768,12.1,12.1,0,0,0-3.712,9,11.889,11.889,0,0,0,3.712,8.942,12.188,12.188,0,0,0,8.942,3.712,11.852,11.852,0,0,0,8.885-3.712,12.188,12.188,0,0,0,3.712-8.942,12.185,12.185,0,0,0-3.712-9A11.7,11.7,0,0,0,238.253,20Zm6.692,19.4a9.183,9.183,0,0,1-6.636,2.812H238.2a9.5,9.5,0,0,1-6.692-16.2,9.311,9.311,0,0,1,6.692-2.812h.112a9.183,9.183,0,0,1,6.636,2.812,9.5,9.5,0,0,1,0,13.384Z",
    transform: "translate(-98.73 -8.753)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M277.286,8.8h-3.149v5.624H270.2v3.205h3.937v9.56a11.852,11.852,0,0,0,3.712,8.885,12.188,12.188,0,0,0,8.942,3.712h2.7V36.637h-2.756a9.409,9.409,0,0,1-9.5-9.448v-9.56h12.2V14.424h-12.2V8.8Z",
    transform: "translate(-118.248 -3.851)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 3.149,
    height: 18.558,
    transform: "translate(200.765 17.377)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 3.149,
    height: 35.879,
    transform: "translate(208.807 0.056)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 3.149,
    height: 35.879,
    transform: "translate(216.849 0.056)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M0,39.8v2.474H5.061a18.161,18.161,0,0,1,0-2.474Z",
    transform: "translate(0 -17.418)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M75,39.8a18.159,18.159,0,0,1,0,2.474h5.061V39.8Z",
    transform: "translate(-32.822 -17.418)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M39.7,75v5.061h2.474V75A18.159,18.159,0,0,1,39.7,75Z",
    transform: "translate(-17.374 -32.822)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M42.274,5.061V0H39.8V5.061A18.161,18.161,0,0,1,42.274,5.061Z",
    transform: "translate(-17.418)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M27.1,57.866a16,16,0,0,1-3.88-.844A14.929,14.929,0,0,1,13.431,44.2H10.9A17.477,17.477,0,0,0,22.372,59.384,17.764,17.764,0,0,0,27.1,60.4V57.866Z",
    transform: "translate(-4.77 -19.343)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M48.924,11.912A17.764,17.764,0,0,0,44.2,10.9v2.531a16,16,0,0,1,3.88.844A14.929,14.929,0,0,1,57.866,27.1H60.4A17.609,17.609,0,0,0,48.924,11.912Z",
    transform: "translate(-19.343 -4.77)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M57.022,48.08A14.929,14.929,0,0,1,44.2,57.866V60.4A17.477,17.477,0,0,0,59.384,48.924,17.764,17.764,0,0,0,60.4,44.2H57.866A13.733,13.733,0,0,1,57.022,48.08Z",
    transform: "translate(-19.343 -19.343)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M14.274,23.316A14.929,14.929,0,0,1,27.1,13.531V11A17.477,17.477,0,0,0,11.912,22.472,17.764,17.764,0,0,0,10.9,27.2h2.531A14.93,14.93,0,0,1,14.274,23.316Z",
    transform: "translate(-4.77 -4.814)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M33.923,26.6a8.706,8.706,0,0,0-6.973,5.68,9.941,9.941,0,0,0-.45,1.743h2.531a5.265,5.265,0,0,1,.225-.9,6.336,6.336,0,0,1,4.611-3.993V26.6Z",
    transform: "translate(-11.597 -11.641)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M29.131,44.2H26.6a8.706,8.706,0,0,0,5.68,6.973,9.94,9.94,0,0,0,1.743.45V49.093a5.264,5.264,0,0,1-.9-.225A6.517,6.517,0,0,1,29.131,44.2Z",
    transform: "translate(-11.641 -19.343)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M45.943,27.05A9.941,9.941,0,0,0,44.2,26.6v2.531a5.266,5.266,0,0,1,.9.225,6.336,6.336,0,0,1,3.993,4.611h2.531A8.709,8.709,0,0,0,45.943,27.05Z",
    transform: "translate(-19.343 -11.641)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M44.2,48.993v2.531a8.706,8.706,0,0,0,6.973-5.68,9.94,9.94,0,0,0,.45-1.743H49.093a5.264,5.264,0,0,1-.225.9A6.4,6.4,0,0,1,44.2,48.993Z",
    transform: "translate(-19.343 -19.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M360.2,20.4a1.8,1.8,0,1,1-1.8-1.8A1.812,1.812,0,0,1,360.2,20.4Z",
    transform: "translate(-156.06 -8.14)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoothillFooterLogo);
export default __webpack_public_path__ + "static/media/shoothillFooterLogo.05c0b1127eb28a08ef577e4bd9af8216.svg";
export { ForwardRef as ReactComponent };